var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"book-property is-hidden-mobile"},[_c('b-tooltip',{staticClass:"subnav-tooltip",attrs:{"label":"Property navigation","position":"is-bottom","type":"is-dark","always":""}}),_c('b-tooltip',{staticClass:"availability-tooltip",attrs:{"label":"Book your property","position":"is-left","type":"is-dark","always":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }